export const constant = {
	selector: {
		container: 'data-elis-container',
	},
}
